import React, { useCallback, useContext, useState } from 'react'
import { Button, Box, IconButton, DialogActions, Dialog, useTheme, useMediaQuery } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { deleteCalificaciones } from '../../../pages/Calificaciones/services/calificaciones.services'
import { TenantsContext } from '../../../context/tenants.context'
import SnackBarUtils from '../../../utils/SnackBarUtils'

interface ConfirmarDeleteProps {
  open: boolean
  setOpen: (op: boolean) => void
  idCalificacion: number
  codLocal: string
  updateData: (codLocal: string) => Promise<void>
}

const ConfirmarDelete: React.FC<ConfirmarDeleteProps> = ({ open, setOpen, idCalificacion, codLocal, updateData }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const [loading, setLoading] = useState<boolean>(false)
  const { tenant } = useContext(TenantsContext)

  const handleEliminar = useCallback(
    async (impideCalificacion: boolean) => {
      try {
        setLoading(true)
        await deleteCalificaciones(tenant, idCalificacion, impideCalificacion)
        SnackBarUtils.success('Calficación eliminada correctamente')
        codLocal && updateData(codLocal)
      } catch (e) {
        SnackBarUtils.error('Error al eliminar la calificación')
      } finally {
        setLoading(false)
        setOpen(false)
      }
    },
    [tenant, idCalificacion, codLocal]
  )

  return (
    <>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        PaperProps={{
          sx: {
            display: 'flex',
            width: isMobile ? '90%' : { xs: '90vw', sm: 550 },
            maxWidth: isMobile ? '90%' : '90vw',
            marginLeft: '-16px',
            overflowX: 'hidden'
          }
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '20px', padding: '10px', paddingTop: '40px' }}>
          <Button color="error" variant="contained" onClick={() => handleEliminar(false)}>
            Eliminar y permitir que califique de nuevo al local
          </Button>
          <Button color="error" variant="contained" onClick={() => handleEliminar(true)}>
            Eliminar y NO permitir que califique de nuevo al local
          </Button>
        </Box>
        <DialogActions>
          <IconButton
            disabled={loading}
            edge="end"
            onClick={() => setOpen(false)}
            style={{
              position: 'absolute',
              top: '0',
              right: '0',
              paddingRight: '14px'
            }}
          >
            <CloseIcon />
          </IconButton>
          <Button
            sx={{ display: 'flex', alignSelf: 'left' }}
            disabled={loading}
            variant="outlined"
            onClick={() => setOpen(false)}
            color="error"
            size="small"
          >
            Cancelar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default ConfirmarDelete
